<template>
  <section class="py-[60px] xl:pt-[80px] xl:pb-[160px]">
    <SectionTitle
      class="!items-start"
      :title="
        $t('landing.trustedInfo.title', { year: new Date().getFullYear() })
      "
    />
    <div class="w-full grid grid-cols-1 md:grid-cols-2 gap-10">
      <CardInfo
        class="items-start"
        v-for="(info, idx) of trustedInfoStatistics"
        :key="idx"
        :value="formatSliceNumber(info?.value)"
        :title="$t(info?.title)"
        colored
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import SectionTitle from "@/modules/Landing/components/Common/SectionTitle.vue";
import { trustedInfoStatistics } from "@/data/index";
import { formatSliceNumber } from "@/utils/index";
import CardInfo from "@/modules/Landing/components/Card/Info.vue";
</script>

<style scoped></style>
